/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandalone404, DynamicStandalone404Props } from './404';
import { DynamicStandalone500, DynamicStandalone500Props } from './500';
import { DynamicStandaloneAccordion, DynamicStandaloneAccordionProps } from './Accordion';
import { DynamicStandaloneAdTemplate, DynamicStandaloneAdTemplateProps } from './AdTemplate';
import { DynamicStandaloneAdunit, DynamicStandaloneAdunitProps } from './Adunit';
import { DynamicStandaloneAffiliateGallery, DynamicStandaloneAffiliateGalleryProps } from './AffiliateGallery';
import { DynamicStandaloneAffiliateItem, DynamicStandaloneAffiliateItemProps } from './AffiliateItem';
import { DynamicStandaloneArticle, DynamicStandaloneArticleProps } from './Article';
import { DynamicStandaloneArticleBodytext, DynamicStandaloneArticleBodytextProps } from './ArticleBodytext';
import { DynamicStandaloneArticleDate, DynamicStandaloneArticleDateProps } from './ArticleDate';
import { DynamicStandaloneArticleDisclosureLabel, DynamicStandaloneArticleDisclosureLabelProps } from './ArticleDisclosureLabel';
import { DynamicStandaloneArticleFooter, DynamicStandaloneArticleFooterProps } from './ArticleFooter';
import { DynamicStandaloneArticleHeader, DynamicStandaloneArticleHeaderProps } from './ArticleHeader';
import { DynamicStandaloneArticleSlider, DynamicStandaloneArticleSliderProps } from './ArticleSlider';
import { DynamicStandaloneArticleTeaserBodytext, DynamicStandaloneArticleTeaserBodytextProps } from './ArticleTeaser/Bodytext';
import { DynamicStandaloneArticleTeaserDefault, DynamicStandaloneArticleTeaserDefaultProps } from './ArticleTeaser/Default';
import { DynamicStandaloneAuthorDetails, DynamicStandaloneAuthorDetailsProps } from './AuthorDetails';
import { DynamicStandaloneAuthorsList, DynamicStandaloneAuthorsListProps } from './AuthorsList';
import { DynamicStandaloneBanner, DynamicStandaloneBannerProps } from './Banner';
import { DynamicStandaloneBase, DynamicStandaloneBaseProps } from './Base';
import { DynamicStandaloneBlogSlider, DynamicStandaloneBlogSliderProps } from './BlogSlider';
import { DynamicStandaloneBox, DynamicStandaloneBoxProps } from './Box';
import { DynamicStandaloneBreakingNews, DynamicStandaloneBreakingNewsProps } from './BreakingNews';
import { DynamicStandaloneButton, DynamicStandaloneButtonProps } from './Button';
import { DynamicStandaloneByline, DynamicStandaloneBylineProps } from './Byline';
import { DynamicStandaloneBylineGroup, DynamicStandaloneBylineGroupProps } from './BylineGroup';
import { DynamicStandaloneCheckbox, DynamicStandaloneCheckboxProps } from './Checkbox';
import { DynamicStandaloneColumns, DynamicStandaloneColumnsProps } from './Columns';
import { DynamicStandaloneConsent, DynamicStandaloneConsentProps } from './Consent';
import { DynamicStandaloneContentLock, DynamicStandaloneContentLockProps } from './ContentLock';
import { DynamicStandaloneCoverBox, DynamicStandaloneCoverBoxProps } from './CoverBox';
import { DynamicStandaloneEdge, DynamicStandaloneEdgeProps } from './Edge';
import { DynamicStandaloneFacebook, DynamicStandaloneFacebookProps } from './Facebook';
import { DynamicStandaloneFactbox, DynamicStandaloneFactboxProps } from './Factbox';
import { DynamicStandaloneFallback, DynamicStandaloneFallbackProps } from './Fallback';
import { DynamicStandaloneFooter, DynamicStandaloneFooterProps } from './Footer';
import { DynamicStandaloneFront, DynamicStandaloneFrontProps } from './Front';
import { DynamicStandaloneFrontCoverstory, DynamicStandaloneFrontCoverstoryProps } from './FrontCoverstory';
import { DynamicStandaloneHamburger, DynamicStandaloneHamburgerProps } from './Hamburger';
import { DynamicStandaloneHeading, DynamicStandaloneHeadingProps } from './Heading';
import { DynamicStandaloneIcon, DynamicStandaloneIconProps } from './Icon';
import { DynamicStandaloneImage, DynamicStandaloneImageProps } from './Image';
import { DynamicStandaloneInstagram, DynamicStandaloneInstagramProps } from './Instagram';
import { DynamicStandaloneInstagramArticlesList, DynamicStandaloneInstagramArticlesListProps } from './InstagramArticlesList';
import { DynamicStandaloneJwVideoArticle, DynamicStandaloneJwVideoArticleProps } from './JwVideo/Article';
import { DynamicStandaloneJwVideoShoppable, DynamicStandaloneJwVideoShoppableProps } from './JwVideo/Shoppable';
import { DynamicStandaloneJwVideoTeaser, DynamicStandaloneJwVideoTeaserProps } from './JwVideo/Teaser';
import { DynamicStandaloneLink, DynamicStandaloneLinkProps } from './Link';
import { DynamicStandaloneList, DynamicStandaloneListProps } from './List';
import { DynamicStandaloneLoader, DynamicStandaloneLoaderProps } from './Loader';
import { DynamicStandaloneLoopAround, DynamicStandaloneLoopAroundProps } from './LoopAround';
import { DynamicStandaloneMain, DynamicStandaloneMainProps } from './Main';
import { DynamicStandaloneMarkup, DynamicStandaloneMarkupProps } from './Markup';
import { DynamicStandaloneMostRead, DynamicStandaloneMostReadProps } from './MostRead';
import { DynamicStandaloneNavigation, DynamicStandaloneNavigationProps } from './Navigation';
import { DynamicStandaloneNewsletterSignup, DynamicStandaloneNewsletterSignupProps } from './NewsletterSignup';
import { DynamicStandaloneNoInfinityTeaserBoxTitle, DynamicStandaloneNoInfinityTeaserBoxTitleProps } from './NoInfinityTeaserBoxTitle';
import { DynamicStandaloneOptionalLink, DynamicStandaloneOptionalLinkProps } from './OptionalLink';
import { DynamicStandalonePageMeta, DynamicStandalonePageMetaProps } from './PageMeta';
import { DynamicStandaloneParagraph, DynamicStandaloneParagraphProps } from './Paragraph';
import { DynamicStandalonePre, DynamicStandalonePreProps } from './Pre';
import { DynamicStandaloneProse, DynamicStandaloneProseProps } from './Prose';
import { DynamicStandaloneQuotebox, DynamicStandaloneQuoteboxProps } from './Quotebox';
import { DynamicStandaloneRadioButton, DynamicStandaloneRadioButtonProps } from './RadioButton';
import { DynamicStandaloneRecommendedArticles, DynamicStandaloneRecommendedArticlesProps } from './RecommendedArticles';
import { DynamicStandaloneRichtextbox, DynamicStandaloneRichtextboxProps } from './Richtextbox';
import { DynamicStandaloneRow, DynamicStandaloneRowProps } from './Row';
import { DynamicStandaloneSaveArticleButton, DynamicStandaloneSaveArticleButtonProps } from './SaveArticleButton';
import { DynamicStandaloneSavedArticles, DynamicStandaloneSavedArticlesProps } from './SavedArticles';
import { DynamicStandaloneSchemaMarkup, DynamicStandaloneSchemaMarkupProps } from './SchemaMarkup';
import { DynamicStandaloneScrollPageControls, DynamicStandaloneScrollPageControlsProps } from './ScrollPageControls';
import { DynamicStandaloneSearch, DynamicStandaloneSearchProps } from './Search';
import { DynamicStandaloneSecondNativeArticle, DynamicStandaloneSecondNativeArticleProps } from './SecondNativeArticle';
import { DynamicStandaloneShowsSlider, DynamicStandaloneShowsSliderProps } from './ShowsSlider';
import { DynamicStandaloneSliderSlide, DynamicStandaloneSliderSlideProps } from './Slider/Slide';
import { DynamicStandaloneSliderSwiper, DynamicStandaloneSliderSwiperProps } from './Slider/Swiper';
import { DynamicStandaloneSoMe, DynamicStandaloneSoMeProps } from './SoMe';
import { DynamicStandaloneSpinner, DynamicStandaloneSpinnerProps } from './Spinner';
import { DynamicStandaloneStateProviders, DynamicStandaloneStateProvidersProps } from './StateProviders';
import { DynamicStandaloneStrossle, DynamicStandaloneStrossleProps } from './Strossle';
import { DynamicStandaloneTag, DynamicStandaloneTagProps } from './Tag';
import { DynamicStandaloneTagsIndex, DynamicStandaloneTagsIndexProps } from './TagsIndex';
import { DynamicStandaloneTextArea, DynamicStandaloneTextAreaProps } from './TextArea';
import { DynamicStandaloneTextField, DynamicStandaloneTextFieldProps } from './TextField';
import { DynamicStandaloneTextMultiline, DynamicStandaloneTextMultilineProps } from './TextMultiline';
import { DynamicStandaloneTextSubtitle, DynamicStandaloneTextSubtitleProps } from './TextSubtitle';
import { DynamicStandaloneTextTitle, DynamicStandaloneTextTitleProps } from './TextTitle';
import { DynamicStandaloneTiktok, DynamicStandaloneTiktokProps } from './Tiktok';
import { DynamicStandaloneTracking, DynamicStandaloneTrackingProps } from './Tracking';
import { DynamicStandaloneTrendingMenu, DynamicStandaloneTrendingMenuProps } from './TrendingMenu';
import { DynamicStandaloneTwitter, DynamicStandaloneTwitterProps } from './Twitter';
import { DynamicStandaloneVideoReels, DynamicStandaloneVideoReelsProps } from './VideoReels';
import { DynamicStandaloneYouplay, DynamicStandaloneYouplayProps } from './Youplay';
import { DynamicStandaloneYoutube, DynamicStandaloneYoutubeProps } from './Youtube';
import { DynamicStandaloneMemberOffers, DynamicStandaloneMemberOffersProps } from './MemberOffers';

export type DynamicStandaloneComponentsProps = {
  404: DynamicStandalone404Props;
  500: DynamicStandalone500Props;
  Accordion: DynamicStandaloneAccordionProps;
  AdTemplate: DynamicStandaloneAdTemplateProps;
  Adunit: DynamicStandaloneAdunitProps;
  AffiliateGallery: DynamicStandaloneAffiliateGalleryProps;
  AffiliateItem: DynamicStandaloneAffiliateItemProps;
  Article: DynamicStandaloneArticleProps;
  ArticleBodytext: DynamicStandaloneArticleBodytextProps;
  ArticleDate: DynamicStandaloneArticleDateProps;
  ArticleDisclosureLabel: DynamicStandaloneArticleDisclosureLabelProps;
  ArticleFooter: DynamicStandaloneArticleFooterProps;
  ArticleHeader: DynamicStandaloneArticleHeaderProps;
  ArticleSlider: DynamicStandaloneArticleSliderProps;
  ArticleTeaserBodytext: DynamicStandaloneArticleTeaserBodytextProps;
  ArticleTeaserDefault: DynamicStandaloneArticleTeaserDefaultProps;
  AuthorDetails: DynamicStandaloneAuthorDetailsProps;
  AuthorsList: DynamicStandaloneAuthorsListProps;
  Banner: DynamicStandaloneBannerProps;
  Base: DynamicStandaloneBaseProps;
  BlogSlider: DynamicStandaloneBlogSliderProps;
  Box: DynamicStandaloneBoxProps;
  BreakingNews: DynamicStandaloneBreakingNewsProps;
  Button: DynamicStandaloneButtonProps;
  Byline: DynamicStandaloneBylineProps;
  BylineGroup: DynamicStandaloneBylineGroupProps;
  Checkbox: DynamicStandaloneCheckboxProps;
  Columns: DynamicStandaloneColumnsProps;
  Consent: DynamicStandaloneConsentProps;
  ContentLock: DynamicStandaloneContentLockProps;
  CoverBox: DynamicStandaloneCoverBoxProps;
  Edge: DynamicStandaloneEdgeProps;
  Facebook: DynamicStandaloneFacebookProps;
  Factbox: DynamicStandaloneFactboxProps;
  Fallback: DynamicStandaloneFallbackProps;
  Footer: DynamicStandaloneFooterProps;
  Front: DynamicStandaloneFrontProps;
  FrontCoverstory: DynamicStandaloneFrontCoverstoryProps;
  Hamburger: DynamicStandaloneHamburgerProps;
  Heading: DynamicStandaloneHeadingProps;
  Icon: DynamicStandaloneIconProps;
  Image: DynamicStandaloneImageProps;
  Instagram: DynamicStandaloneInstagramProps;
  InstagramArticlesList: DynamicStandaloneInstagramArticlesListProps;
  JwVideoArticle: DynamicStandaloneJwVideoArticleProps;
  JwVideoShoppable: DynamicStandaloneJwVideoShoppableProps;
  JwVideoTeaser: DynamicStandaloneJwVideoTeaserProps;
  Link: DynamicStandaloneLinkProps;
  List: DynamicStandaloneListProps;
  Loader: DynamicStandaloneLoaderProps;
  LoopAround: DynamicStandaloneLoopAroundProps;
  Main: DynamicStandaloneMainProps;
  Markup: DynamicStandaloneMarkupProps;
  MostRead: DynamicStandaloneMostReadProps;
  Navigation: DynamicStandaloneNavigationProps;
  NewsletterSignup: DynamicStandaloneNewsletterSignupProps;
  NoInfinityTeaserBoxTitle: DynamicStandaloneNoInfinityTeaserBoxTitleProps;
  OptionalLink: DynamicStandaloneOptionalLinkProps;
  PageMeta: DynamicStandalonePageMetaProps;
  Paragraph: DynamicStandaloneParagraphProps;
  Pre: DynamicStandalonePreProps;
  Prose: DynamicStandaloneProseProps;
  Quotebox: DynamicStandaloneQuoteboxProps;
  RadioButton: DynamicStandaloneRadioButtonProps;
  RecommendedArticles: DynamicStandaloneRecommendedArticlesProps;
  Richtextbox: DynamicStandaloneRichtextboxProps;
  Row: DynamicStandaloneRowProps;
  SaveArticleButton: DynamicStandaloneSaveArticleButtonProps;
  SavedArticles: DynamicStandaloneSavedArticlesProps;
  SchemaMarkup: DynamicStandaloneSchemaMarkupProps;
  ScrollPageControls: DynamicStandaloneScrollPageControlsProps;
  Search: DynamicStandaloneSearchProps;
  SecondNativeArticle: DynamicStandaloneSecondNativeArticleProps;
  ShowsSlider: DynamicStandaloneShowsSliderProps;
  SliderSlide: DynamicStandaloneSliderSlideProps;
  SliderSwiper: DynamicStandaloneSliderSwiperProps;
  SoMe: DynamicStandaloneSoMeProps;
  Spinner: DynamicStandaloneSpinnerProps;
  StateProviders: DynamicStandaloneStateProvidersProps;
  Strossle: DynamicStandaloneStrossleProps;
  Tag: DynamicStandaloneTagProps;
  TagsIndex: DynamicStandaloneTagsIndexProps;
  TextArea: DynamicStandaloneTextAreaProps;
  TextField: DynamicStandaloneTextFieldProps;
  TextMultiline: DynamicStandaloneTextMultilineProps;
  TextSubtitle: DynamicStandaloneTextSubtitleProps;
  TextTitle: DynamicStandaloneTextTitleProps;
  Tiktok: DynamicStandaloneTiktokProps;
  Tracking: DynamicStandaloneTrackingProps;
  TrendingMenu: DynamicStandaloneTrendingMenuProps;
  Twitter: DynamicStandaloneTwitterProps;
  VideoReels: DynamicStandaloneVideoReelsProps;
  Youplay: DynamicStandaloneYouplayProps;
  Youtube: DynamicStandaloneYoutubeProps;
  MemberOffers: DynamicStandaloneMemberOffersProps;
}

export const DynamicStandaloneComponents = {
  404: DynamicStandalone404,
  500: DynamicStandalone500,
  Accordion: DynamicStandaloneAccordion,
  AdTemplate: DynamicStandaloneAdTemplate,
  Adunit: DynamicStandaloneAdunit,
  AffiliateGallery: DynamicStandaloneAffiliateGallery,
  AffiliateItem: DynamicStandaloneAffiliateItem,
  Article: DynamicStandaloneArticle,
  ArticleBodytext: DynamicStandaloneArticleBodytext,
  ArticleDate: DynamicStandaloneArticleDate,
  ArticleDisclosureLabel: DynamicStandaloneArticleDisclosureLabel,
  ArticleFooter: DynamicStandaloneArticleFooter,
  ArticleHeader: DynamicStandaloneArticleHeader,
  ArticleSlider: DynamicStandaloneArticleSlider,
  ArticleTeaserBodytext: DynamicStandaloneArticleTeaserBodytext,
  ArticleTeaserDefault: DynamicStandaloneArticleTeaserDefault,
  AuthorDetails: DynamicStandaloneAuthorDetails,
  AuthorsList: DynamicStandaloneAuthorsList,
  Banner: DynamicStandaloneBanner,
  Base: DynamicStandaloneBase,
  BlogSlider: DynamicStandaloneBlogSlider,
  Box: DynamicStandaloneBox,
  BreakingNews: DynamicStandaloneBreakingNews,
  Button: DynamicStandaloneButton,
  Byline: DynamicStandaloneByline,
  BylineGroup: DynamicStandaloneBylineGroup,
  Checkbox: DynamicStandaloneCheckbox,
  Columns: DynamicStandaloneColumns,
  Consent: DynamicStandaloneConsent,
  ContentLock: DynamicStandaloneContentLock,
  CoverBox: DynamicStandaloneCoverBox,
  Edge: DynamicStandaloneEdge,
  Facebook: DynamicStandaloneFacebook,
  Factbox: DynamicStandaloneFactbox,
  Fallback: DynamicStandaloneFallback,
  Footer: DynamicStandaloneFooter,
  Front: DynamicStandaloneFront,
  FrontCoverstory: DynamicStandaloneFrontCoverstory,
  Hamburger: DynamicStandaloneHamburger,
  Heading: DynamicStandaloneHeading,
  Icon: DynamicStandaloneIcon,
  Image: DynamicStandaloneImage,
  Instagram: DynamicStandaloneInstagram,
  InstagramArticlesList: DynamicStandaloneInstagramArticlesList,
  JwVideoArticle: DynamicStandaloneJwVideoArticle,
  JwVideoShoppable: DynamicStandaloneJwVideoShoppable,
  JwVideoTeaser: DynamicStandaloneJwVideoTeaser,
  Link: DynamicStandaloneLink,
  List: DynamicStandaloneList,
  Loader: DynamicStandaloneLoader,
  LoopAround: DynamicStandaloneLoopAround,
  Main: DynamicStandaloneMain,
  Markup: DynamicStandaloneMarkup,
  MostRead: DynamicStandaloneMostRead,
  Navigation: DynamicStandaloneNavigation,
  NewsletterSignup: DynamicStandaloneNewsletterSignup,
  NoInfinityTeaserBoxTitle: DynamicStandaloneNoInfinityTeaserBoxTitle,
  OptionalLink: DynamicStandaloneOptionalLink,
  PageMeta: DynamicStandalonePageMeta,
  Paragraph: DynamicStandaloneParagraph,
  Pre: DynamicStandalonePre,
  Prose: DynamicStandaloneProse,
  Quotebox: DynamicStandaloneQuotebox,
  RadioButton: DynamicStandaloneRadioButton,
  RecommendedArticles: DynamicStandaloneRecommendedArticles,
  Richtextbox: DynamicStandaloneRichtextbox,
  Row: DynamicStandaloneRow,
  SaveArticleButton: DynamicStandaloneSaveArticleButton,
  SavedArticles: DynamicStandaloneSavedArticles,
  SchemaMarkup: DynamicStandaloneSchemaMarkup,
  ScrollPageControls: DynamicStandaloneScrollPageControls,
  Search: DynamicStandaloneSearch,
  SecondNativeArticle: DynamicStandaloneSecondNativeArticle,
  ShowsSlider: DynamicStandaloneShowsSlider,
  SliderSlide: DynamicStandaloneSliderSlide,
  SliderSwiper: DynamicStandaloneSliderSwiper,
  SoMe: DynamicStandaloneSoMe,
  Spinner: DynamicStandaloneSpinner,
  StateProviders: DynamicStandaloneStateProviders,
  Strossle: DynamicStandaloneStrossle,
  Tag: DynamicStandaloneTag,
  TagsIndex: DynamicStandaloneTagsIndex,
  TextArea: DynamicStandaloneTextArea,
  TextField: DynamicStandaloneTextField,
  TextMultiline: DynamicStandaloneTextMultiline,
  TextSubtitle: DynamicStandaloneTextSubtitle,
  TextTitle: DynamicStandaloneTextTitle,
  Tiktok: DynamicStandaloneTiktok,
  Tracking: DynamicStandaloneTracking,
  TrendingMenu: DynamicStandaloneTrendingMenu,
  Twitter: DynamicStandaloneTwitter,
  VideoReels: DynamicStandaloneVideoReels,
  Youplay: DynamicStandaloneYouplay,
  Youtube: DynamicStandaloneYoutube,
  MemberOffers: DynamicStandaloneMemberOffers,
}
